var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "112px",
    height: "112px",
    viewBox: "0 0 112 112",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons / Iconset / 112 / power") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.6237226,94 C35.4851709,94 35.34442,93.9889464 35.2014699,93.960207 C34.0908572,93.7568203 33.2859379,92.7841016 33.2859379,91.65 L33.2859379,56.4 L18.7050232,56.4 C16.6091542,56.3977893 14.8123808,55.0824083 14.2317833,53.1281279 L0.209473777,6.05296331 C-0.230372821,4.56956726 0.0313359045,2.975635 0.9110291,1.78626529 C1.7511361,0.649952963 3.05308203,0 4.48258347,0 L41.8497512,0 C43.1407009,0 44.1875358,1.05451552 44.1875358,2.35221072 C44.1875358,3.64990593 43.1407009,4.7 41.8497512,4.7 L4.68931137,4.7 L4.68931137,4.70221072 L18.6852301,51.6911571 L34.0050871,51.7 C36.1537377,51.7022107 37.9637065,53.5437441 37.959308,55.7213076 L37.959308,78.8034807 L55.2342831,32.9265287 C55.2386816,32.9176858 55.2408808,32.9088429 55.2452793,32.9022107 L36.4022511,32.9022107 C35.7336842,32.8889464 33.8511408,32.9022107 32.7493251,31.34365 C31.596927,29.707714 32.3006815,27.6915334 32.6393634,26.7188147 L35.7226881,16.5494826 C36.0987569,15.3070555 37.4073005,14.6062559 38.638871,14.9865005 C39.87484,15.3645343 40.5697976,16.6754939 40.1937287,17.9201317 L37.0796148,28.1845249 C37.0774156,28.1867357 37.0774156,28.1933678 37.0752164,28.2022107 L55.8632638,28.2022107 L55.8676622,28.2022107 C57.2597767,28.2022107 58.489148,28.8300564 59.2390864,29.9309972 C60.1055842,31.2021637 60.2397374,32.9508467 59.6019599,34.6088899 L37.8075609,92.4812324 C37.4600821,93.4075259 36.5803889,94 35.6237226,94",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Iconset-/-112-/-power",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path",
    transform: "translate(25.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#1A171B",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    mask: "url(#mask-2)",
    points: "-25 -9 87 -9 87 103 -25 103"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIcon);
export default __webpack_public_path__ + "static/media/power_icon.dfc64c2d5477277dab9ae9bc9292bfd0.svg";
export { ForwardRef as ReactComponent };